<template>
		<el-container>
		  <el-main>
		  	<homeMain :isMobile="isMobile" :screenWidth="screenWidth"/>
        <breadcrumb v-if="!['homePage','myHome','myInfo','myEvaluate','myDoneFile','myHbBuDoneFile','myGovernment',
          'myMaterial','myCollection','myFootprint','myMessage'
        ].includes($route.name)"/>
		  	<router-view :isMobile="isMobile" :screenWidth="screenWidth"/>
		  </el-main>
		  <el-footer>
		  	<homeFooter :isMobile="isMobile" :screenWidth="screenWidth"/>
		  </el-footer>
		</el-container>
</template>

<script>
import homeMain from '@/components/home/homeMain.vue'
import breadcrumb from '@/components/breadcrumb.vue'
import homeFooter from '@/components/home/homeFooter.vue'

export default {
  name: 'HomeView',
  components: {
    homeMain,breadcrumb,homeFooter
  },
  created(){
    // 获取字典数据 并缓存到window
    // this.getDictData()
  },
  mounted () {
    this.screenWidth = document.body.clientWidth
    this.screenChange(this.screenWidth)
    window.onresize = () => {
    return (() => {
        this.screenWidth = document.body.clientWidth
    })()
    }

  },
  watch: {
      screenWidth: {
          handler: function (val, oldVal) {
              this.screenChange(val)
          }
      },
      immediate: true
  },
  data() {
      return {
          screenWidth: null,
          isMobile: false,
      }
  },
  methods: {
    getDictData(){
      if (!window.SITE_CONFIG['dictData']) {
        this.$http({
          url: this.$http.adornUrl('/dict/getDictList'),
          method: 'get'
        }).then(({ data }) => {
          if (data.code === 0) {
            let d_data = data.data
            let o_data = {}
            d_data.forEach(item => {
              let dictType = item.dictType
              o_data[dictType] = item.dataList
            })
            window.SITE_CONFIG['dictData'] = o_data
            console.log('字典：',  window.SITE_CONFIG['dictData'])
          }
        })
      }
    },
      screenChange(val){
        this.isMobile = (val <= window.SITE_CONFIG['mobilePx'])
      },
    searchKey(item){
      this.selectedKey = item.key
      console.log('data: ', item)
    },
    clickNavHandle(menu){
      console.log('菜单：',menu)
      this.$router.push(menu.path)
    }
  }
  }
</script>

<style>
.el-header {
  color: #333;
  text-align: center;
  line-height: 40px;
  height: 40px !important;
  background-color: #eee;
}
.el-footer {
  background-color: #333;
  height:unset !important;
  padding-right:unset !important;
  padding-left:unset !important;
}
.el-main {
  background-color: #fff;
  color: #333;
  padding: 0 !important;
  height:calc(100%-320px) !important;
}
</style>
